import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { addUrlProps, UrlQueryParamTypes, multiPushInUrlQuery, Serialize } from 'react-url-query';
import { connect, PromiseState } from 'react-refetch';

import PromiseStateContainer from '../../apiAccess/PromiseStateContainer';
import BASE_URL from '../../apiAccess/urls';
import SearchNav from '../searchNav/SearchNav';
import MultiFoodQueryBuilder from './MultiFoodQueryBuilder';
import MultiFoodResult from './MultiFoodResult';
import { getValidFoods, getValidGroup, getValidReport } from '../../util/util';
import PrintHeader from '../../presentation/Print/PrintHeader';
import PrintDisclaimer from '../../presentation/Print/PrintDisclaimer';

const urlPropsQueryConfig = {
  foods: { type: UrlQueryParamTypes.string },
  group: { type: UrlQueryParamTypes.string },
  report: { type: UrlQueryParamTypes.string },
  per100g: { type: UrlQueryParamTypes.boolean },
};

const handleSubmit = function(query) {
  const foods = query.foods.map(food => food.recordid).join(',');
  // onChangeXXX does not push history. use multiPushInUrlQuery.
  // per100g stays the same on new search
  multiPushInUrlQuery({
    foods: foods,
    group: query.group,
    report: query.report,
  });
};

const handlePerChange = function(newPer100g) {
  multiPushInUrlQuery({
    per100g: newPer100g === true ? Serialize.encodeBoolean(newPer100g) : '',
  });
};

/**
 * Concerns of this component:
 *   control url query
 *   fetch /food
 *   fetch /food/group
 *   validate 'foods' and 'group' from url query
**/
class MultiFoodSearch extends Component {
  constructor(props) {
    super(props);
    this.renderOnFulfillment = this.renderOnFulfillment.bind(this);
  }

  render() {
    const { foodFetch, groupFetch } = this.props;
    return (
      <PromiseStateContainer
        ps={PromiseState.all([foodFetch, groupFetch])}
        onFulfillment={this.renderOnFulfillment}
      />
    );
  }

  renderOnFulfillment([foods, groups]) {
    let validFoods = getValidFoods(this.props.foods, foods);
    // limit number of foods up to 3.
    if (validFoods.length > 3) {
      validFoods = validFoods.splice(0, 3);
    }
    const validGroup = getValidGroup(this.props.group);
    const validReport = getValidReport(this.props.report);
    const validPer100g = this.props.per100g ? true : false;

    return (
      <div className="MultiFoodSearch">
        <Helmet title="Multi-Food Search - New Zealand Food Composition Database" />

        <PrintHeader title='MULTI-FOOD SEARCH' />

        <SearchNav currentPath={this.props.match.url}>
          <MultiFoodQueryBuilder
            foods={foods}
            groups={groups}
            selectedFoods={validFoods}
            selectedGroup={validGroup}
            selectedReport={validReport}
            handleSubmit={handleSubmit}
          />
        </SearchNav>

        {validFoods.length > 0 &&
          <MultiFoodResult
            selectedFoods={validFoods}
            selectedReport={validReport}
            per100g={validPer100g}
            handlePerChange={handlePerChange}
          />
        }

        <PrintDisclaimer />
      </div>
    );
  }
}

MultiFoodSearch.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
  foods: PropTypes.string,
  group: PropTypes.string,
  report: PropTypes.string,
  per100g: PropTypes.bool,
  foodFetch: PropTypes.instanceOf(PromiseState),
  groupFetch: PropTypes.instanceOf(PromiseState),
};

const fetch = () => ({
  foodFetch: `${BASE_URL}/food`,
  groupFetch: `${BASE_URL}/food/group`,
});

export default addUrlProps({ urlPropsQueryConfig })(connect(fetch)(MultiFoodSearch));



// WEBPACK FOOTER //
// ./src/components/search/multiFood/MultiFoodSearch.js